import {
  RunConfigService,
  ConfigService,
  BrowserDetection
} from "@nuskin/ns-util";
import axios from "axios";

import { Product } from "@nuskin/ns-product-lib";

export default {
  getProductData
};

/**
 * Used to retrieve product content and product status for products requested from the product data lambda.
 * @param skus The product skus to request data for.
 * @param locale The locale for market-specific product data and translations.
 * @return {Promise.<*>}
 */
async function getProductData(skus, locale) {
  const runConfig = RunConfigService.getRunConfig();
  const marketConfig = ConfigService.getMarketConfig();

  if (!locale) {
    locale = `${runConfig.language}_${runConfig.country}`;
  }

  let lambdaUrl = `${marketConfig.awsUrl}/productData/v1`;
  const payload = {
    locale: locale,
    skus: skus
  };
  const productDataResponse = await axios.request({
    method: "post",
    url: lambdaUrl,
    data: payload,
    headers: getProductDataRequestHeaders(marketConfig),
    responseType: "json"
  });

  const productData = processProductDataResponse(
    marketConfig,
    productDataResponse
  );
  return productData;
}

function processProductDataResponse(marketConfig, productDataResponse) {
  if (!productDataResponse || !productDataResponse.data) {
    return undefined;
  }

  let productData = productDataResponse.data;
  if (productData.data) {
    // the actual response is nested in another data for now
    productData = productData.data;
  }

  if (productData.products && productData.products.length) {
    const siteUrl = marketConfig.siteUrl;
    const isEdge = BrowserDetection.isEdge();
    const isFirefox = BrowserDetection.isFirefox();

    productData.products = productData.products.map((pdata) =>
      mapProductFromResponse(siteUrl, isEdge, isFirefox, pdata)
    );
  }

  return productData;
}

function mapProductFromResponse(siteUrl, isEdge, isFirefox, pdata) {
  const product = new Product(pdata);

  // set the base url for images, etc
  product.setBaseUrl(siteUrl);

  // fix image paths for non-edge/firefox
  if (!isEdge && !isFirefox) {
    product.fullImage = product.fullImage
      ? `${product.fullImage.split("?")[0]}?format=pjpg`
      : undefined;
    product.thumbnail = product.thumbnail
      ? `${product.thumbnail.split("?")[0]}?format=pjpg`
      : undefined;
  }

  return product;
}

/**
 * Returns headers required to call product data lambda
 * @returns {{Content-Type: string, client_id: string, client_secret: string}}
 * @private
 */
function getProductDataRequestHeaders(marketConfig) {
  return {
    "Content-Type": "application/json",
    client_id: marketConfig.checkout.clientId,
    client_secret: marketConfig.checkout.clientSecret
  };
}
